import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import { closeHandler, getMessageStatus } from './messagesHelper';
//TODO: to be removed with s-dash 2 migration 
import { SDashAlertCloseButton } from '../helper/sdash-pollyfills';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import { SAlert } from '@avalara/skylab-sdk/react';
const log = new Logger('APPLICATION_MESSAGES', LOG_LEVELS.DEBUG);

class ApplicationMessages extends Component {

  render() {
    const linkTo = this.props.linkTo;
    log.debug('render(): ', this.props);
    const messageStatus = getMessageStatus(this.props.messageType);
  
    return (
      <div className="mb10">
          {
            this.props.messages.map((entry, index) => {
              if(linkTo) {
                return (
                  <SAlert key={entry.message && (entry.message.id || entry.message.languageString)} status={messageStatus} role="alert" onS-dismiss={closeHandler(entry, log)}>
                    <Link to={this.props.linkTo}>
                      <LanguageStringResolver
                        string={entry.message.languageString}
                        tooltip={entry.message.extendedLanguageString}
                        params={entry.args}
                        tooltipWithParams={this.props.tooltipWithParams}
                        tooltipOffset={this.props.tooltipOffset}
                      />
                      <SDashAlertCloseButton onClose={closeHandler(entry, log)} />
                    </Link>
                  </SAlert>
                );
              } else {
                return (
                  <SAlert key={entry.message && (entry.message.id || entry.message.languageString)} status={messageStatus} role="alert" noDismiss={this.props.disableDismiss} onS-dismiss={closeHandler(entry, log)}>
                    <LanguageStringResolver
                      string={entry.message.languageString}
                      tooltip={entry.message.extendedLanguageString}
                      params={entry.args}
                      tooltipWithParams={this.props.tooltipWithParams}
                      tooltipOffset={this.props.tooltipOffset}
                    />
                    {this.props.children}
                    {!this.props.disableDismiss && <SDashAlertCloseButton onClose={closeHandler(entry, log)} />}
                  </SAlert>
                );
              }
            })
          }
      </div>
    );
  }
}


ApplicationMessages.defaultProps = {
  tooltipWithParams: true
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): ', state, props);
  const inAppMessages = (state.logger && state.logger.inAppMessages) || [];
  const types = props.messageType;
  const scopes = Array.isArray(props.scopes) ? props.scopes : typeof props.scopes === 'string' ? [props.scopes] : undefined;
  const messageIds = Array.isArray(props.messageIds) ? props.messageIds : typeof props.messageIds === 'number' ? [props.messageIds] : undefined;
  const excludedMessageIds = Array.isArray(props.excludedMessageIds) ? props.excludedMessageIds : typeof props.excludedMessageIds === 'number' ? [props.excludedMessageIds] : undefined;

  const messages = inAppMessages.filter((entry) => {
    return entry.message && (!types || types.indexOf(entry.message.type) >=0 ) 
    && (!scopes || scopes.indexOf(entry.scope) >= 0) 
    && (!messageIds || messageIds.indexOf(entry.message.id) >=0)
    && (!excludedMessageIds || excludedMessageIds.indexOf(entry.message.id) ===-1);
  });
  const messagesByType = messages.reduce((byType, entry) => {
    if (!entry && !entry.message) {
      return byType;
    }
    if (!byType[entry.message.type]) {
      byType[entry.message.type] = []
    }
    byType[entry.message.type].push(entry);
    return byType;
  }, {});
  return {
    messages,
    messagesByType
  };
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(ApplicationMessages);